import { UserContext } from '@zola-helpers/client/dist/es/@types';
import type { MobileNavLink } from '../MobileNavMenuData';

export default function getMobileExpertAdviceMenuData(userContext: UserContext): MobileNavLink[][] {
  const hasChecklist = userContext?.wedding_account?.checklist_id;
  return [
    [
      {
        title: `${!hasChecklist ? 'Start ' : ''}Your Wedding Checklist`,
        path: '/wedding/manage/wedding-checklist',
      },
    ],
    [
      { title: 'See All Expert Advice', path: '/expert-advice' },
      { title: 'Planning 101 ', path: '/expert-advice/topic/planning-101' },
      {
        title: 'Decor + Inspiration ',
        path: '/expert-advice/topic/decor-inspiration',
      },
      { title: 'Invites + Paper ', path: '/expert-advice/topic/invites-paper' },
      { title: 'Wedding Party ', path: '/expert-advice/topic/wedding-party' },
      {
        title: 'Pre-Wedding Activities ',
        path: '/expert-advice/topic/pre-wedding-activities',
      },
      { title: 'Registry ', path: '/expert-advice/topic/registry' },
      { title: 'Wedding Guests ', path: '/expert-advice/topic/wedding-guests' },
      { title: 'Honeymoon ', path: '/expert-advice/topic/honeymoon' },
      { title: 'Newlywed Life ', path: '/expert-advice/topic/newlywed-life' },
      { title: 'COVID-19 ', path: '/expert-advice/topic/covid-19' },
    ],
  ];
}
